export default __webpack_public_path__ + "static/media/study.6de63dae.svg";